export default {
    //url:'http://test.tsied.com/api/v1',
    //'http://202.120.35.193/api/v1',
    url: process.env.VUE_APP_API_ROOT?process.env.VUE_APP_API_ROOT:window.location.origin+'/zbs/api/zoom',
    modules: {
        SignIn: '/user/login',
        Profile: '/user/profile',
        Admin: {
            Parameter: {},
            ZoomRoom: {},
            Visitor: {},
            SysLog: {},
            ZoomAccount:{},
            Organization:{},
        }
    }
}
